import { render, staticRenderFns } from "./PesquisaAlimentosAdequados.vue?vue&type=template&id=3824370c&scoped=true"
import script from "./PesquisaAlimentosAdequados.vue?vue&type=script&lang=js"
export * from "./PesquisaAlimentosAdequados.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAlimentosAdequados.vue?vue&type=style&index=0&id=3824370c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824370c",
  null
  
)

export default component.exports